<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-toolbar text color="white">
          <v-toolbar-title>Rate Plans</v-toolbar-title>
          <v-divider class="mx-2" inset vertical></v-divider>
          <v-col>
            <v-subheader>Click on a row to see associated Rules</v-subheader>
          </v-col>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="80vw">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" @click="getRatePlans"
                >Refresh</v-btn
              >
              <v-btn color="primary" dark class="mb-2" @click="newRatePlans"
                >New Rate Plan</v-btn
              >
              <v-btn color="primary" dark class="mb-2" @click="checkMissing()"
                >Check Missing</v-btn
              >
            </template>
            <v-card>
              <app-title>New Rate Plan</app-title>

              <v-card-text>
                <v-container>
                  <v-row v-if="editedItem">
                    <v-col
                      md="6"
                      v-for="(item, index) in getHeaders(editedItem)"
                      :key="index"
                    >
                      <v-select
                        v-if="
                          item.text == 'usageType' ||
                            item.text == 'productType' ||
                            [
                              'payInitialComms',
                              'forcePayInitial',
                              'hasSpecialOverride',
                              'monitorDataUsage',
                              'expanded'
                            ].includes(item.value)
                        "
                        v-model="editedItem[item.text]"
                        :label="item.text"
                        :items="
                          [
                            'payInitialComms',
                            'forcePayInitial',
                            'hasSpecialOverride',
                            'monitorDataUsage',
                            'expanded'
                          ].includes(item.value)
                            ? boolOptions
                            : item.text == 'usageType'
                            ? usageTypes
                            : productTypes
                        "
                        @change="
                          item.text == 'usageType'
                            ? setProductTypes(editedItem)
                            : ''
                        "
                      ></v-select>
                      <v-text-field
                        v-else
                        v-model="editedItem[item.text]"
                        :label="item.text"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  v-if="editedItem.id > 0"
                  color="blue darken-1"
                  text
                  @click="remove"
                  >Remove</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-text-field
          name="search"
          label="Search"
          v-model="search"
          prepend-icon="search"
        ></v-text-field>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          :search.sync="search"
          show-expand=""
          single-expand=""
        >
          <template v-slot:header="{ headers }">
            <tr>
              <th
                v-for="header in headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:item="{ item, headers }">
            <tr @click="item.expanded = !item.expanded">
              <td
                :class="`text-xs-${name.align}`"
                v-for="(name, index) in headers"
                :key="index"
              >
                <span v-if="name.value.includes('date')">{{
                  item[name.value] | formatDate
                }}</span>
                <span v-else>{{ item[name.value] }}</span>
              </td>
              <td>
                <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ item, headers }">
            <v-card flat>
              <v-card-text v-if="rules">
                <rule-detail
                  :details="item.tblPlanDealerCommissions"
                  :ratePlanId="props.item.ratePlanId"
                ></rule-detail>
              </v-card-text>
            </v-card>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <missing-plan
      :missingDialog="missingDialog"
      @closeDialog="closeDialog"
    ></missing-plan>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import RatePlan from "@/models/RatePlan";
import ruleDetail from "@/components/commissions/ruleDetail";
import MissingPlan from "@/components/commissions/missing-plan";
export default {
  name: "EditRatePlans",
  components: {
    ruleDetail,
    MissingPlan
  },
  data() {
    return {
      dialog: false,
      missingDialog: false,
      runType: 1,
      search: null,
      items: [],
      rules: [],
      editedItem: {},
      headers: [
        {
          text: "Rate Plan ID",
          value: "ratePlanId",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        },
        {
          text: "Description",
          value: "ratePlanDescription",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 380
        },
        {
          text: "Usage Type",
          value: "usageType",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        },
        {
          text: "Product Type",
          value: "productType",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        },
        {
          text: "Pay Initial",
          value: "payInitialComms",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        },
        {
          text: "Rule Count",
          value: "count",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        }
      ],
      typeOptions: [
        {
          usageType: "DSL",
          productTypes: ["DSL"]
        },
        {
          usageType: "Fibre",
          productTypes: ["Fibre"]
        },
        {
          usageType: "NBN",
          productTypes: ["NBN"]
        },
        {
          usageType: "Vonex PBX",
          productTypes: ["PBX"]
        },
        {
          usageType: "Wholesale Service",
          productTypes: ["Wholesale"]
        },
        {
          usageType: "Mobile",
          productTypes: ["Mobile Broadband", "Mobile Voice"]
        },
        {
          usageType: "Voice",
          productTypes: ["Voice", "Rebill", "ULL"]
        },
        {
          usageType: "VoIP",
          productTypes: [
            "VOIP",
            "SIP",
            "Finance",
            "Hardware",
            "Corporate",
            "Other"
          ]
        }
      ],
      productTypes: [],
      boolOptions: [true, false]
    };
  },
  methods: {
    ...mapActions("commissions", ["CommissionsRequest"]),
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    newRatePlans() {
      this.editedItem = new RatePlan({});
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },
    remove() {
      let query = {
        message: `Dealer Type removed`,
        url: `Commissions/DeleteRatePlan/`,
        method: "post",
        body: this.editedItem
      };
      this.CommissionsRequest(query)
        .then(data => {
          this.$emit("collected");
          this.items = data;
        })
        .catch(() => {});
    },
    save() {
      this.editedItem.id = parseInt(this.editedItem.id);
      this.editedItem.ratePlanId = parseInt(this.editedItem.ratePlanId);
      this.editedItem.qantasPoints = parseInt(this.editedItem.qantasPoints);
      this.editedItem.dataAllowance = parseInt(this.editedItem.dataAllowance);
      this.editedItem.contractMonths = parseInt(this.editedItem.contractMonths);
      this.editedItem.qantasBonusPoints = parseInt(
        this.editedItem.qantasBonusPoints
      );
      this.editedItem.qantasPoints = parseInt(this.editedItem.qantasPoints);
      this.editedItem.excessDataCharge = parseInt(
        this.editedItem.excessDataCharge
      );
      this.editedItem.monthlyRetail = parseFloat(this.editedItem.monthlyRetail);
      this.editedItem.monthlyProfitPercent = parseFloat(
        this.editedItem.monthlyProfitPercent
      );

      this.editedItem.handset = !!this.editedItem.handset;
      this.editedItem.monitorDataUsage = !!this.editedItem.monitorDataUsage;
      this.editedItem.payInitialComms = !!this.editedItem.payInitialComms;
      this.editedItem.hasSpecialOverride = !!this.editedItem.hasSpecialOverride;
      this.editedItem.qantasPlan = !!this.editedItem.qantasPlan;
      this.editedItem.forcePayInitial = !!this.editedItem.forcePayInitial;

      let query = {
        message: `Dealer Type added`,
        url: `Commissions/EditRatePlans/`,
        method: "post",
        body: [this.editedItem]
      };
      this.CommissionsRequest(query)
        .then(data => {
          this.$emit("collected");
          this.items = data;
        })
        .catch(() => {});
    },
    getRatePlans() {
      let query = {
        message: `RatePlans collected`,
        url: `Commissions/GetRatePlansWithRules`,
        method: "get",
        body: {}
      };
      this.CommissionsRequest(query)
        .then(data => {
          this.$emit("collected");
          this.items = data.map(x => ({
            ...x
            // count: x.tblPlanDealerCommissions.length
          }));
        })
        .catch(() => {});
    },

    editItem(val) {
      this.editedItem = Object.assign({}, val);
      this.setProductTypes(val);
      this.dialog = true;
    },
    parseBool(str) {
      if (str == null) return false;

      if (typeof str === "boolean") {
        return str === true;
      }

      if (typeof str === "string") {
        if (str == "") return false;

        str = str.replace(/^\s+|\s+$/g, "");
        if (str.toLowerCase() == "true" || str.toLowerCase() == "yes")
          return true;

        str = str.replace(/,/g, ".");
        str = str.replace(/^\s*\-\s*/g, "-");
      }

      if (!isNaN(str)) return parseFloat(str) != 0;

      return false;
    },
    getProductTypes(item) {
      return this.typeOptions
        .filter(x => x.usageType === item)
        .map(x => x.productTypes)[0];
    },
    setProductTypes(item) {
      let usageTypes = [
        "DSL",
        "Fibre",
        "NBN",
        "Vonex PBX",
        "Wholesale Service"
      ];
      this.productTypes = this.typeOptions
        .filter(x => x.usageType == item.usageType)
        .map(x => x.productTypes)[0];

      if (usageTypes.includes(item.usageType))
        this.editedItem.productType = this.getProductTypes(item.usageType)[0];
    },
    checkMissing() {
      this.missingDialog = true;
    },
    closeDialog() {
      let vm = this;
      vm.getRatePlans();
      vm.missingDialog = false;
    }
  },
  computed: {
    usageTypes() {
      return this.typeOptions.map(x => {
        return x.usageType;
      });
    }
  }
};
</script>

<style scoped></style>
